module.exports = __webpack_public_path__ + "img/kkb_sm58.a1c97af9.jpg";